<template>
  <div class="im-groups">
    <List
      v-for="list in lists"
      :key="list.id"
      :id="list.id"
      :opened="false"
      :title="list.title"
      :items="list.items"
      :count="list.count"
      :selectable="list.allowMassMessage"
      :isShowMore="list.users && list.users.nextPage > 0"
      @openList="openGroup($event)"
      @clickItem="clickUser($event)"
      @changeItem="changeSelectUsers($event)"
      @changeItems="changeSelectUsers($event)"
      @moreItems="moreUsers($event)"
    />
  </div>
</template>

<script>
  import List from '../shared/list/List.vue';
  import { dialog } from '../../mixins/dialog';

  export default {
    name: 'Users',
    mixins: [dialog],
    components: {
      List
    },
    data() {
      return {
        currentLists: null
      };
    },
    mounted() {
      this.$store.dispatch('setGroups');
      this.$bus.$on('closeDialog', (payload) => {
        const list = this.currentLists.find(list => list.id === payload.id);
        if (list) {
          list.items.forEach(item => {
            item.select = false;
          });
        }
      });
    },
    computed: {
      lists() {
        this.currentLists = this.setLists(this.$store.state.groups);
        return this.currentLists;
      }
    },
    methods: {
      setLists(data) {
        return data.map(list => {
          list.items = [];
          if(list.users){
            list.items = list.users.items.map(item => {
              return {...item, select: false };
            });
          }
          list.selectable = true;
          return list;
        });
      },
      openGroup(id) {
        const group = this.$store.state.groups.find(item => item.id === id);
        if (group.items.length === 0) {
          this.$store.dispatch('setUsers', { id: group.id, page: 1 });
        }
      },
      moreUsers(id){
        const group = this.$store.state.groups.find(item => item.id === id);
        const { nextPage } = group.users;
        const { currentPage } = group.users;
        if(nextPage > currentPage){
          this.$store.dispatch('setUsers', { id: group.id, page: nextPage });
        }
      },
      async clickUser(data) {
        const payload = {
          key: 'u'+data.item.id,
          id: data.item.id,
          title: data.item.name,
          value: null,
          users: [data.item],
          group: null
        };
        this.updateDialog(payload, false);
      },
      async changeSelectUsers(data) {
        const payload = {
          key: 'g'+data.list.id,
          id: data.list.id,
          title: data.list.title,
          users: data.selectedItems,
          group: data.list
        };
        this.updateDialog(payload, true);
      },
      async updateDialog(data, isGroup) {
        const dialog = this.$store.state.dialog;
        if (dialog && dialog.key === data.key) {
          if (isGroup) {
            this.updateGroupDialog(data);
          }
        } else {
          const existDialog = this.$store.state.dialogs.find(item => item.key === data.key);
          if (existDialog) {
            await this.$store.dispatch('openDialog', data);
            if (isGroup) {
              this.updateGroupDialog(data);
            }
          } else {
            this.createDialog(data);
          }
        }
      },
    }
  };
</script>

<style scoped>

</style>